export const hasQuestStarted = (date: string) => {
  return date && new Date(date).getTime() < Date.now();
};
